export const USER_SIGNED_IN = 'USER_SIGNED_IN';
export type USER_SIGNED_IN = typeof USER_SIGNED_IN;

export const USER_SIGNED_OUT = 'USER_SIGNED_OUT';
export type USER_SIGNED_OUT = typeof USER_SIGNED_OUT;

export const USER_SIGNED_UP = 'USER_SIGNED_UP';
export type USER_SIGNED_UP = typeof USER_SIGNED_UP;

export const USER_CLOSE_ACCOUNT = 'USER_CLOSE_ACCOUNT';
export type USER_CLOSE_ACCOUNT = typeof USER_CLOSE_ACCOUNT;

// ToDo: Move to correct file
export const PhoneNumberRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

export const ChangePasswordRegex = /^(?!.* )(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;

// accepted values of NotApplicable  - NA n.a n/a and numeric only of length 9
export const MIDRegex = /^[nN][/]?[.]?[aA][.]?$|^\d{9}$/;

// accepted values of NotApplicable  - NA n.a n/a and numeric only of length 6 or 9
export const MIDLength6and9Regex = /^[nN][\/.]?[aA][.]?$|^\d{6}$|^\d{9}$/;

// PHv2 rateSet api throw error when fetching by company name for these special characters
export const CompanyNameRegex = /^[^:\{\}\[\]\?<>\%\^*+=,._-]+$/;

export const dummyPaymentData = {
	ACHPaymentAccountRequest: {
		routingNumber: '123456789',
		accountHolderName: 'DefaultACHMethod',
		accountNumber: '123456789',
		active: false,
		default: false,
		country: 'string',
		address1: 'string',
		address2: 'string',
		city: 'string',
		state: 'string',
		postalCode: '1234',
		phoneNumber: '9999999999',
	},
	CreditCardPaymentAccountRequest: {
		cardNumber: '4111111111111111',
		cardHolderName: 'DefaultCardMethod',
		expirationMonth: '4',
		expirationYear: '2021',
		securityCode: '111',
		active: false,
		default: false,
		country: 'string',
		address1: 'string',
		address2: 'string',
		city: 'string',
		state: 'string',
		postalCode: '123456',
	},
};

export const transactionIdStarting = 'PHv3-PORTAL-';
export const AddNewUSPSTierRoutedFromTierDropDown = 'AddNewUSPSTierRoutedFromTierDropDown';

export const minimumAppsRequiredPerAccount = 1;



// WEBPACK FOOTER //
// ./src/constants/account.constants.ts